import request from '../utils/request'
import { getStateUser } from '../utils/store';

export const uploadDataset = async (formData) => {
  const user = getStateUser();
  const url = `users/${user.id}/datasets/upload`;
  return await request(url, 'POST', formData);
};
